module.exports = __webpack_public_path__ + "static/Epic-Ride-db2d740d6435a78873691af582c1660c.ttf";